import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Compass } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const { completeOAuth } = useAuth();
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    completeOAuth(sessionId);
  }, [completeOAuth, location.hash]);
  return <div data-testid="auth-callback-screen" className="flex min-h-screen items-center justify-center gap-3 bg-stone-50 font-['Figtree']">
    <Compass className="h-6 w-6 animate-spin text-ac" />
    <p data-testid="auth-callback-status" role="status" className="text-sm text-stone-600">Getting your plans ready…</p>
  </div>;
}
